import { render, staticRenderFns } from "./BzComment.vue?vue&type=template&id=da548c74&scoped=true&"
import script from "./BzComment.vue?vue&type=script&lang=js&"
export * from "./BzComment.vue?vue&type=script&lang=js&"
import style0 from "./BzComment.vue?vue&type=style&index=0&id=da548c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da548c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VIcon,VRow,VTextField})
